import { render, staticRenderFns } from "./IconTemplate.vue?vue&type=template&id=324f38c0&scoped=true&lang=pug"
import script from "./IconTemplate.vue?vue&type=script&lang=js"
export * from "./IconTemplate.vue?vue&type=script&lang=js"
import style0 from "./IconTemplate.vue?vue&type=style&index=0&id=324f38c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324f38c0",
  null
  
)

export default component.exports